module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Grid</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 subsection\">\r\n            <label class=\"prop-sublabel label-35\">Width</label>\r\n            <div>\r\n                <input id=\"gridWidth\" name=\"gridWidth\" type=\"text\" style=\"width: 35px;\" value=\"")
    ; __append(escapeFn( gridWidth ))
    ; __append("\" tabindex=\"35\" /> px\r\n            </div>\r\n        </div>\r\n        \r\n        <div class=\"col-md-6 subsection\"> \r\n            <label class=\"prop-sublabel label-35\">Height</label>\r\n            <div>\r\n                <input id=\"gridHeight\" name=\"gridHeight\" type=\"text\" style=\"width: 35px;\" value=\"")
    ; __append(escapeFn( gridHeight ))
    ; __append("\" tabindex=\"36\" /> px\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}